export default __webpack_public_path__ + "static/media/NTEX CLASS-9 EXAM PATTERN 2025.3a0f6a69.pdf";